"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUnfavoriteUseCase = void 0;
const react_query_1 = require("@tanstack/react-query");
const favorites_context_1 = require("../../providers/favorites/favorites.context");
function useUnfavoriteUseCase(params) {
    const { favoritesRepository, queryContext, tagService, onSuccess, onError } = params;
    const queryClient = (0, react_query_1.useQueryClient)({ context: queryContext });
    const { mutateAsync: unfavorite } = (0, react_query_1.useMutation)({
        mutationKey: favorites_context_1.FavoritesQueryKeys.RemoveItem(favoritesRepository.strategyName),
        mutationFn: (product) => __awaiter(this, void 0, void 0, function* () {
            return yield favoritesRepository.removeItem(product);
        }),
        onMutate: (product) => __awaiter(this, void 0, void 0, function* () {
            tagService.unfavorite(product.sku);
        }),
        onSuccess: (result) => {
            queryClient.setQueryData(favorites_context_1.FavoritesQueryKeys.GetAll(favoritesRepository.strategyName), result);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        },
        onError: () => {
            onError === null || onError === void 0 ? void 0 : onError();
        },
        context: queryContext,
    });
    return unfavorite;
}
exports.useUnfavoriteUseCase = useUnfavoriteUseCase;
